import ApiService from './ApiService'

export async function apiSignIn(data) {
    return ApiService.fetchData({
        url: '/api/auth/sign-in',
        method: 'post',
        data,
    })
}

export async function apiSignUp(data) {
    return ApiService.fetchData({
        url: '/api/auth/sign-up',
        method: 'post',
        data,
    })
}

export async function apiSignOut() {
    return ApiService.fetchData({
        url: '/api/auth/sign-out',
        method: 'post',
    })
}

export async function apiForgotPassword(data) {
    return ApiService.fetchData({
        url: '/api/auth/forgot-password',
        method: 'post',
        data,
    })
}

export async function apiResetPassword(data) {
    return ApiService.fetchData({
        url: '/api/auth/reset-password',
        method: 'post',
        data,
    })
}